import { PII_MARKERS } from './consts';

const knownPiiStrings = new Set();

const escapeForRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Lookbehind and Unicode property escapes shipped in WebKit with Safari 16.4 (Mar 2023).
// Older WebKit throws SyntaxError on construction, so we detect once and fall back to ASCII \b.
// Probe uses the exact syntax + flags of the modern branch so feature parity is guaranteed.
const supportsModernBoundaries = (() => {
  try {
    // Must use the RegExp constructor — a regex literal would throw at parse time on
    // engines lacking these features, before this try/catch could intercept it.
    // eslint-disable-next-line prefer-regex-literals
    return Boolean(new RegExp('(?<![\\p{L}\\p{N}_])a(?![\\p{L}\\p{N}_])', 'giu'));
  } catch {
    return false;
  }
})();

const buildPattern = (escaped) =>
  supportsModernBoundaries
    ? new RegExp(`(?<![\\p{L}\\p{N}_])${escaped}(?![\\p{L}\\p{N}_])`, 'giu')
    : new RegExp(`\\b${escaped}\\b`, 'gi');

export const registerKnownPii = (value) => {
  if (typeof value !== 'string') return;
  const trimmed = value.trim();
  if (trimmed.length < 2) return;
  knownPiiStrings.add(trimmed);
};

export const clearKnownPii = () => {
  knownPiiStrings.clear();
};

export const redactKnownPii = (text) => {
  if (typeof text !== 'string' || knownPiiStrings.size === 0) return text;
  return Array.from(knownPiiStrings)
    .sort((a, b) => b.length - a.length || a.localeCompare(b))
    .reduce((acc, pii) => acc.replace(buildPattern(escapeForRegex(pii)), PII_MARKERS.NAME), text);
};
